import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WalletIcon(props: IconProps) {
    return <Icon {...props} iconKey={"wallet"}/>
}
